import { Icon, PropertyFilterProps, TableProps } from '@amzn/awsui-components-core';
import { numberFormatter } from 'src/utilities/CommonUtilities';
import { UserMetricsParsedData } from './UserMetricsInterfaces';
import React from 'react';
import { getPhoneToolUrl } from '../FinTechOpsCommonElements';
import { indicatorIcon, indicatorIconVariant } from '../fintech-ops-dashboard/FinTechOpsUtils';

export const USER_METRICS_FOOTPRINT_VISIBLE_CONTENT = [
  'team_name',
  'app_type',
  'distinctUsers',
  'newUsers',
  'returningUsers',
  'retainedUsers',
  'lostUsers',
  'userCount',
  'avgPageViewPerDay',
  'active_since'
];

export const USER_METRICS_FOOTPRINT_FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Team',
    key: 'team_name',
    groupValuesLabel: 'Team',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Application',
    key: 'app_type',
    groupValuesLabel: 'Application',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Distinct Users',
    key: 'distinctUsers',
    groupValuesLabel: 'Distinct Users',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'User Activity',
    key: 'userCount',
    groupValuesLabel: 'User Activity',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Active Since',
    key: 'active_since',
    groupValuesLabel: 'Active Since',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Avg PageViews Per Day',
    key: 'avgPageViewPerDay',
    groupValuesLabel: 'Avg PageViews Per Day',
    operators: [':', '!:', '=', '!=']
  }
];

export const USER_METRICS_FOOTPRINT_COLUMN_DEFINITIONS: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'app_type',
    sortingField: 'app_type',
    header: 'Application',
    cell: (item: any) => item.app_type,
    width: 200
  },
  {
    id: 'team_name',
    sortingField: 'team_name',
    header: 'Team',
    cell: (item: any) => item.team_name,
    width: 130
  },

  {
    id: 'distinctUsers',
    sortingComparator: (a: any, b: any) => {
      return a.distinctUsers - b.distinctUsers;
    },
    header: 'Distinct User Count',
    cell: (item: any) => numberFormatter(item.distinctUsers),
    width: 200
  },
  {
    id: 'newUsers',
    sortingComparator: (a: any, b: any) => a.newUsers - b.newUsers,
    header: 'New Users',
    cell: (item: any) => numberFormatter(item.newUsers),
    width: 150
  },
  {
    id: 'returningUsers',
    sortingComparator: (a: any, b: any) => a.returningUsers - b.returningUsers,
    header: 'Returning Users',
    cell: (item: any) => numberFormatter(item.returningUsers),
    width: 170
  },
  {
    id: 'retainedUsers',
    sortingComparator: (a: any, b: any) => a.retainedUsers - b.retainedUsers,
    header: 'Retained Users',
    cell: (item: any) => numberFormatter(item.retainedUsers),
    width: 170
  },
  {
    id: 'lostUsers',
    sortingComparator: (a: any, b: any) => a.lostUsers - b.lostUsers,
    header: 'Lost Users',
    cell: (item: any) => numberFormatter(item.lostUsers),
    width: 170
  },
  {
    id: 'userCount',
    sortingComparator: (a: any, b: any) => {
      return a.userCount - b.userCount;
    },
    header: 'User Activity',
    cell: (item: any) => numberFormatter(item.userCount),
    width: 170
  },
  {
    id: 'active_since',
    sortingField: 'active_since',
    header: 'Active Since',
    cell: (item: any) => item.active_since,
    width: 220
  },
  {
    id: 'avgPageViewPerDay',
    sortingComparator: (a: any, b: any) => {
      return a.avgPageViewsPerDay - b.avgPageViewsPerDay;
    },
    header: 'Avg PageViews Per Day',
    cell: (item: any) => numberFormatter(item.avgPageViewsPerDay),
    width: 170
  }
];

export const USER_METRICS_SUB_APPLICATION_FOOTPRINT_VISIBLE_CONTENT = ['app_name', ...USER_METRICS_FOOTPRINT_VISIBLE_CONTENT];

export const USER_METRICS_SUB_APPLICATION_FOOTPRINT_FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Sub Application',
    key: 'app_name',
    groupValuesLabel: 'Sub Application',
    operators: [':', '!:', '=', '!=']
  },
  ...USER_METRICS_FOOTPRINT_FILTERING_PROPERTIES
];

export const USER_METRICS_SUB_APPLICATION_FOOTPRINT_COLUMN_DEFINITIONS: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'app_name',
    sortingField: 'app_name',
    header: 'Sub Application',
    cell: (item: any) => item.app_name,
    width: 200
  },
  ...USER_METRICS_FOOTPRINT_COLUMN_DEFINITIONS
];

export const USER_METRICS_APPLICATION_USER_VIEW_VISIBLE_CONTENT = [
  'team_name',
  'application_type',
  'user_login',
  'active_since',
  'measure_value',
  'last_active'
];

export const USER_METRICS_APPLICATION_USER_VIEW__FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Team',
    key: 'team_name',
    groupValuesLabel: 'Team',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Application',
    key: 'application_type',
    groupValuesLabel: 'Application',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'User Alias',
    key: 'user_login',
    groupValuesLabel: 'User Alias',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Active since',
    key: 'active_since',
    groupValuesLabel: 'Active since',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Last Accessed',
    key: 'last_active',
    groupValuesLabel: 'Last Accessed',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'View Count',
    key: 'measure_value',
    groupValuesLabel: 'View Count',
    operators: [':', '!:', '=', '!=']
  }
];

export const USER_METRICS_APPLICATION_USER_VIEW__COLUMN_DEFINITIONS: TableProps.ColumnDefinition<UserMetricsParsedData>[] = [
  {
    id: 'application_type',
    sortingField: 'application_type',
    header: 'Application',
    cell: (item: UserMetricsParsedData) => item.application_type,
    minWidth: 150
  },
  {
    id: 'team_name',
    sortingField: 'team_name',
    header: 'Team',
    cell: (item: UserMetricsParsedData) => item.team_name,
    width: 130
  },
  {
    id: 'user_login',
    sortingField: 'user_login',
    header: 'User Alias',
    maxWidth: 100,
    cell: (item: UserMetricsParsedData) => getPhoneToolUrl(item.user_login, item.user_login)
  },
  {
    id: 'active_since',
    sortingField: 'active_since',
    header: 'Active Since',
    cell: (item: UserMetricsParsedData) => item.active_since,
    width: 170
  },
  {
    id: 'last_active',
    sortingField: 'last_active',
    header: 'Last Accessed',
    cell: (item: UserMetricsParsedData) => (item.last_active ? item.last_active : ''),
    width: 170
  },
  {
    id: 'measure_value',
    sortingComparator: (a: any, b: any) => {
      return a.measure_value - b.measure_value;
    },
    header: 'View count',
    cell: (item: UserMetricsParsedData) => numberFormatter(item.measure_value),
    width: 150
  }
];

export const USER_METRICS_SUB_APPLICATION_USER_VIEW_VISIBLE_CONTENT = ['application', ...USER_METRICS_APPLICATION_USER_VIEW_VISIBLE_CONTENT];

export const USER_METRICS_SUB_APPLICATION_USER_VIEW__FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Sub Application',
    key: 'application',
    groupValuesLabel: 'Sub Application',
    operators: [':', '!:', '=', '!=']
  },
  ...USER_METRICS_APPLICATION_USER_VIEW__FILTERING_PROPERTIES
];

export const USER_METRICS_SUB_APPLICATION_USER_VIEW__COLUMN_DEFINITIONS: TableProps.ColumnDefinition<UserMetricsParsedData>[] = [
  {
    id: 'application',
    sortingField: 'application',
    header: 'Sub Application',
    cell: (item: UserMetricsParsedData) => item.application,
    width: 200
  },
  ...USER_METRICS_APPLICATION_USER_VIEW__COLUMN_DEFINITIONS
];

// ===== Lifecycle Health Metrics Table =====

/** Helper to format a percentage value or return '—' for invalid calculations */
const fmtPct = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value) || !isFinite(value)) return '—';
  return `${(value * 100).toFixed(1)}%`;
};

/** Helper to format a ratio or return '—' */
const fmtRatio = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value) || !isFinite(value)) return '—';
  return value.toFixed(2);
};

/**
 * Creates a sorting comparator for pre-computed nullable numeric fields.
 * Nulls are consistently sorted to the bottom (treated as less than any real value).
 * @param field - The pre-computed field name on the row object
 */
const createNullSafeComparator =
  (field: string) =>
  (a: any, b: any): number => {
    const aVal = a[field];
    const bVal = b[field];
    if (aVal === null && bVal === null) return 0;
    if (aVal === null) return -1;
    if (bVal === null) return 1;
    if (aVal === Infinity && bVal === Infinity) return 0;
    if (aVal === Infinity) return 1;
    if (bVal === Infinity) return -1;
    return aVal - bVal;
  };

/** Base lifecycle health columns (shared between app and sub-app tables) */
const LIFECYCLE_HEALTH_BASE_COLUMNS: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'distinctUsers',
    header: 'Distinct Users',
    sortingField: 'distinctUsers',
    cell: (item: any) => numberFormatter(item.distinctUsers) || '0',
    width: 150
  },
  {
    id: 'newUsers',
    header: 'New',
    sortingField: 'newUsers',
    cell: (item: any) => numberFormatter(item.newUsers) || '0',
    width: 90
  },
  {
    id: 'retainedUsers',
    header: 'Retained',
    sortingField: 'retainedUsers',
    cell: (item: any) => numberFormatter(item.retainedUsers) || '0',
    width: 130
  },
  {
    id: 'returningUsers',
    header: 'Returning',
    sortingField: 'returningUsers',
    cell: (item: any) => numberFormatter(item.returningUsers) || '0',
    width: 130
  },
  {
    id: 'lostUsers',
    header: 'Lost',
    sortingField: 'lostUsers',
    cell: (item: any) => numberFormatter(item.lostUsers) || '0',
    width: 90
  },
  {
    id: 'priorPeriodUsers',
    header: 'Prior Period Users',
    sortingField: 'priorPeriodUsers',
    cell: (item: any) => numberFormatter(item.priorPeriodUsers) || '0',
    width: 200
  },
  // --- Core Conversion Percentages ---
  {
    id: 'newUserPct',
    header: 'New User %',
    sortingComparator: createNullSafeComparator('newUserPct'),
    cell: (item: any) => fmtPct(item.newUserPct),
    width: 140
  },
  {
    id: 'retainedUserPct',
    header: 'Retained %',
    sortingComparator: createNullSafeComparator('retainedUserPct'),
    cell: (item: any) => fmtPct(item.retainedUserPct),
    width: 140
  },
  {
    id: 'returningUserPct',
    header: 'Returning %',
    sortingComparator: createNullSafeComparator('returningUserPct'),
    cell: (item: any) => fmtPct(item.returningUserPct),
    width: 160
  },
  {
    id: 'lostUserPct',
    header: 'Lost %',
    sortingComparator: createNullSafeComparator('lostUserPct'),
    cell: (item: any) => fmtPct(item.lostUserPct),
    width: 125
  },
  // --- Funnel / Lifecycle View ---
  {
    id: 'activationRate',
    header: 'Activation Rate',
    sortingComparator: createNullSafeComparator('activationRate'),
    cell: (item: any) => fmtPct(item.activationRate),
    width: 190
  },
  {
    id: 'continuityRate',
    header: 'Continuity Rate',
    sortingComparator: createNullSafeComparator('continuityRate'),
    cell: (item: any) => fmtPct(item.continuityRate),
    width: 190
  },
  {
    id: 'reactivationRate',
    header: 'Reactivation Rate',
    sortingComparator: createNullSafeComparator('reactivationRate'),
    cell: (item: any) => fmtPct(item.reactivationRate),
    width: 175
  },
  // --- Health / Quality Signals ---
  {
    id: 'netGrowthPct',
    header: 'Net Growth %',
    sortingComparator: createNullSafeComparator('netGrowthPct'),
    cell: (item: any) => (
      <>
        {fmtPct(item.netGrowthPct)}
        {item.netGrowthPct != null && <Icon name={indicatorIcon(item.netGrowthPct)} variant={indicatorIconVariant(item.netGrowthPct * -1)} />}
      </>
    ),
    width: 140
  },
  {
    id: 'retentionChurnRatio',
    header: 'Retention Ratio',
    sortingComparator: createNullSafeComparator('retentionChurnRatio'),
    cell: (item: any) => {
      if (item.retentionChurnRatio === Infinity) return '∞';
      return fmtRatio(item.retentionChurnRatio);
    },
    width: 160
  },
  {
    id: 'engagedUserPct',
    header: 'Engaged User %',
    sortingComparator: createNullSafeComparator('engagedUserPct'),
    cell: (item: any) => fmtPct(item.engagedUserPct),
    width: 170
  },
  {
    id: 'activityPerUser',
    header: 'Activity/User',
    sortingComparator: createNullSafeComparator('activityPerUser'),
    cell: (item: any) => (item.activityPerUser !== null ? item.activityPerUser.toFixed(1) : '—'),
    width: 145
  },
  {
    id: 'powerUserPct',
    header: 'Power User %',
    sortingComparator: createNullSafeComparator('powerUserPct'),
    cell: (item: any) => fmtPct(item.powerUserPct),
    width: 145
  }
];

/** Application-level lifecycle health column definitions */
export const USER_METRICS_LIFECYCLE_HEALTH_COLUMN_DEFINITIONS: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'app_type',
    header: 'Application',
    sortingField: 'app_type',
    cell: (item: any) => item.app_type,
    width: 150
  },
  {
    id: 'team_name',
    header: 'Team',
    sortingField: 'team_name',
    cell: (item: any) => item.team_name,
    width: 150
  },
  ...LIFECYCLE_HEALTH_BASE_COLUMNS
];

/** Sub-application-level lifecycle health column definitions */
export const USER_METRICS_SUB_APP_LIFECYCLE_HEALTH_COLUMN_DEFINITIONS: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'app_name',
    header: 'Sub Application',
    sortingField: 'app_name',
    cell: (item: any) => item.app_name,
    width: 160
  },
  {
    id: 'app_type',
    header: 'Application',
    sortingField: 'app_type',
    cell: (item: any) => item.app_type,
    width: 150
  },
  {
    id: 'team_name',
    header: 'Team',
    sortingField: 'team_name',
    cell: (item: any) => item.team_name,
    width: 150
  },
  ...LIFECYCLE_HEALTH_BASE_COLUMNS
];

/** Visible columns for lifecycle health table (application level) */
export const USER_METRICS_LIFECYCLE_HEALTH_VISIBLE_CONTENT: string[] = USER_METRICS_LIFECYCLE_HEALTH_COLUMN_DEFINITIONS.map((col) => col.id || '');

/** Visible columns for lifecycle health table (sub-application level) */
export const USER_METRICS_SUB_APP_LIFECYCLE_HEALTH_VISIBLE_CONTENT: string[] = USER_METRICS_SUB_APP_LIFECYCLE_HEALTH_COLUMN_DEFINITIONS.map(
  (col) => col.id || ''
);

/** Filtering properties for lifecycle health table */
export const USER_METRICS_LIFECYCLE_HEALTH_FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Team',
    key: 'team_name',
    groupValuesLabel: 'Team',
    operators: [':', '!:', '=', '!=']
  },
  {
    propertyLabel: 'Application',
    key: 'app_type',
    groupValuesLabel: 'Application',
    operators: [':', '!:', '=', '!=']
  }
];

/** Filtering properties for sub-app lifecycle health table */
export const USER_METRICS_SUB_APP_LIFECYCLE_HEALTH_FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
  {
    propertyLabel: 'Sub Application',
    key: 'app_name',
    groupValuesLabel: 'Sub Application',
    operators: [':', '!:', '=', '!=']
  },
  ...USER_METRICS_LIFECYCLE_HEALTH_FILTERING_PROPERTIES
];
